export default __webpack_public_path__ + "static/media/delhi.13551d37.png";